export enum MapElementColor {
    Red = 1,
    Orange = 2,
    Yellow = 3,
    Green = 4,
    Aqua = 5,
    Blue = 6,
    Purple = 7,
    Gray = 8,
    Black = 9,
    White = 10,
    NoColor = 11,
}

export enum MapElementColorName {
    Red = "red",
    Orange = "orange",
    Yellow = "yellow",
    Green = "green",
    Aqua = "aqua",
    Blue = "blue",
    Purple = "purple",
    Gray = "gray",
    Black = "black",
    White = "white",
    NoColor = "no color",
}
